// Copyright (c) 2021 WiseTime. All rights reserved.

import * as Grpc from "grpc-web"
import { injectTimelineVersionMetadata } from "./metaData"

// https://grpc.io/blog/grpc-web-interceptor/#unary-interceptor-example
// https://github.com/grpc/grpc-web/blob/master/javascript/net/grpc/web/interceptor.js#L36
export class UnaryRpcInterceptor<Req, Resp> implements Grpc.UnaryInterceptor<Req, Resp> {

  intercept = async <Req, Resp>(
    request: Grpc.Request<Req, Resp>,
    invoker: (request: Grpc.Request<Req, Resp>) => Promise<Grpc.UnaryResponse<Req, Resp>>
  ): Promise<Grpc.UnaryResponse<Req, Resp>> => {
    injectTimelineVersionMetadata(request.getMetadata())
    return await invoker(request)
  }
}

// https://grpc.io/blog/grpc-web-interceptor/#stream-interceptor-example
// https://github.com/grpc/grpc-web/blob/master/javascript/net/grpc/web/interceptor.js#L61
export class ServerStreamingRpcInterceptor<Req, Resp> implements Grpc.StreamInterceptor<Req, Resp> {

  intercept = <Req, Resp>(
    request: Grpc.Request<Req, Resp>,
    invoker: (request: Grpc.Request<Req, Resp>) => Grpc.ClientReadableStream<Resp>
  ): Grpc.ClientReadableStream<Resp> => {
    injectTimelineVersionMetadata(request.getMetadata())
    return invoker(request)
  }
}
